import React, { useState } from "react";
import CustomDropdown from "../../components/CustomComponents/CustomDropdown";
import "./styles/DropdownMenuBtn.scss";
const DropdownMenuBtn = (props) => {

  const { handleResponse,
    handleCopyClick,
    handleEditClick, handleViewClick, data, label } = props;

  const [menu, setMenu] = useState(false);
  const onDeleteOrder = async () => {

  }

  const onEditOrder = () => {
    handleEditClick(data);
  }
  const onViewClick = () => {
    handleViewClick(data);
  }
  const onCopyOrder = () => {
   
      handleCopyClick(data);
  }

  const items = [
    { label: label ? label : 'View Order', onClick: onViewClick },
    // TODO: Phase 2 - Copy and Edit Purchase Order"
    // { label: label ? label : 'Copy Order', onClick: onCopyOrder },
    // { label: label ? label : 'Edit Order', onClick: onEditOrder },
    // { label: 'Delete Order', onClick: onDeleteOrder }
  ]

  return (
    <CustomDropdown
      isOpen={menu}
      direction={'down'}
      toggle={() => setMenu(!menu)}
      items={items}
    />
  );
}
export default DropdownMenuBtn;